import { TextField } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid-pro';

export function QuantityEditCell(props: GridRenderEditCellParams) {
  const { id, field, value, api } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = parseInt(event.target.value, 10);
    if (isNaN(newValue) || newValue < 1) {
      newValue = 1;
    }
    api.setEditCellValue({ id, field, value: newValue }, event);
  };

  return (
    <TextField
      type="number"
      inputProps={{ min: 1, step: 1 }}
      value={value ?? 1}
      onChange={handleChange}
      variant="standard"
      fullWidth
      InputProps={{
        disableUnderline: true
      }}
      sx={{
        height: '100%',
        '& .MuiInputBase-root': {
          height: '100%',
          alignItems: 'center'
        },
        '& input': {
          height: '100%',
          boxSizing: 'border-box',
          padding: 0
        }
      }}
    />
  );
}
